import * as React from 'react'
import './style.css'


export class Mask extends React.Component {

  render() {
    const { children } = this.props
    return (<div className="wk-common-mask-wrap">
      <div className="wk-common-mask">
      </div>
      <div className="wk-common-content">
        {children}
      </div>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/mask/index.js